"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _Headlight = _interopRequireDefault(require("./Headlight.js"));
var _AssignmentModalContents = _interopRequireDefault(require("../ModalContents/AssignmentModalContents.js"));
var _SurveyModalContents = _interopRequireDefault(require("../ModalContents/SurveyModalContents.js"));
var _CourseWrapper = _interopRequireDefault(require("../ModalContents/CourseWrapper"));
var _SessionDataEntry = _interopRequireDefault(require("../ModalContents/SessionDataEntry"));
var _OutcomesDataEntry = _interopRequireDefault(require("../ModalContents/OutcomesDataEntry"));
var _styleAssignmentcard = _interopRequireDefault(require("./style-assignmentcard.css"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _book = _interopRequireDefault(require("cccisd-icons/book3"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _boxAdd = _interopRequireDefault(require("cccisd-icons/box-add"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _boxRemove = _interopRequireDefault(require("cccisd-icons/box-remove"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _broom = _interopRequireDefault(require("cccisd-icons/broom"));
var _admin = require("../../reducers/admin.js");
var _reactRedux = require("react-redux");
var _SurveyCard = _interopRequireDefault(require("./SurveyCard.js"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _HiddenBlock = _interopRequireDefault(require("../HiddenBlock"));
var _HighlightWord = _interopRequireDefault(require("../HighlightWord"));
var _JsonForm = _interopRequireDefault(require("./JsonForm"));
var _generatePreviewHash = _interopRequireDefault(require("../../helpers/generatePreviewHash.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var AssignmentCard = /*#__PURE__*/function (_React$Component) {
  _inherits(AssignmentCard, _React$Component);
  var _super = _createSuper(AssignmentCard);
  function AssignmentCard() {
    var _this;
    _classCallCheck(this, AssignmentCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false
    });
    _defineProperty(_assertThisInitialized(_this), "archiveAssignment", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, assignmentData, assignmentTerm, isSuccess;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, assignmentData = _this$props.assignmentData, assignmentTerm = _this$props.assignmentTerm;
              _this.setState({
                loading: true
              });
              _context.next = 4;
              return _this.props.archiveQuest(assignmentData.assignmentId);
            case 4:
              isSuccess = _context.sent;
              if (isSuccess) {
                (0, _cccisdNotification["default"])("".concat(assignmentTerm, " successfully archived"));
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: "".concat(assignmentTerm, " failed to archive")
                });
                _this.setState({
                  loading: false
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "unarchiveAssignment", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props2, assignmentData, assignmentTerm, isSuccess;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, assignmentData = _this$props2.assignmentData, assignmentTerm = _this$props2.assignmentTerm;
              _this.setState({
                loading: true
              });
              _context2.next = 4;
              return _this.props.unarchiveQuest(assignmentData.assignmentId);
            case 4:
              isSuccess = _context2.sent;
              if (isSuccess) {
                (0, _cccisdNotification["default"])("".concat(assignmentTerm, " successfully unarchived"));
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: "".concat(assignmentTerm, " failed to unarchive")
                });
                _this.setState({
                  loading: false
                });
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "deleteAssignment", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props3, assignmentData, assignmentTerm, isSuccess;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props3 = _this.props, assignmentData = _this$props3.assignmentData, assignmentTerm = _this$props3.assignmentTerm;
              _this.setState({
                loading: true
              });
              _context3.next = 4;
              return _this.props.deleteQuest(assignmentData.assignmentId);
            case 4:
              isSuccess = _context3.sent;
              if (isSuccess) {
                (0, _cccisdNotification["default"])(assignmentTerm + ' successfully deleted');
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: assignmentTerm + ' failed to delete'
                });
                _this.setState({
                  loading: false
                });
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "onUpdateAssignment", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values) {
        var _this$props4, assignmentData, assignmentTerm, isSuccess;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props4 = _this.props, assignmentData = _this$props4.assignmentData, assignmentTerm = _this$props4.assignmentTerm;
                _context4.next = 3;
                return _this.props.updateQuest(assignmentData.assignmentId, _objectSpread(_objectSpread({}, assignmentData.settings), values));
              case 3:
                isSuccess = _context4.sent;
                if (isSuccess) {
                  (0, _cccisdNotification["default"])("".concat(assignmentTerm, " successfully updated"));
                } else {
                  (0, _cccisdNotification["default"])({
                    type: 'danger',
                    message: "".concat(assignmentTerm, " failed to update")
                  });
                }
                _this.editQuestModal.close();
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_renderSurveylistListDropdown", function () {
      var assignmentData = _this.props.assignmentData;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("select", {
        "data-switch-survey-list-list": assignmentData.assignmentId,
        className: "form-control input-sm",
        style: {
          height: '1.9em',
          lineHeight: '1.9em'
        },
        value: assignmentData.currentSurveylistList.surveylistHandle,
        onChange: function onChange(e) {
          return _this.props.setCurrentSurveyListHandle({
            assignmentId: assignmentData.assignmentId,
            handle: e.target.value
          });
        }
      }, assignmentData.surveylistList.map(function (surveylist) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: surveylist.surveylistHandle,
          value: surveylist.surveylistHandle
        }, surveylist.surveylistHandle);
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].headlightPipe
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderHeadlight", function () {
      var _this$props5 = _this.props,
        assignmentTerm = _this$props5.assignmentTerm,
        assignmentData = _this$props5.assignmentData;
      var useCourseWrapper = assignmentData.settings.navigation && assignmentData.settings.navigation.match(/^courseWrapper/);
      var useSessionDataEntry = assignmentData.settings.navigation && assignmentData.settings.navigation.match(/^sessionDataEntry/);
      var useOutcomesDataEntry = assignmentData.settings.navigation && assignmentData.settings.navigation.match(/^outcomesDataEntry/);
      return assignmentData.archived ? /*#__PURE__*/_react["default"].createElement(_Headlight["default"], {
        style: {
          backgroundColor: '#f1f0f4'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Unarchive"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-info",
        "data-unarchive-quest-button": assignmentData.assignmentId,
        onClick: _this.unarchiveAssignment
      }, /*#__PURE__*/_react["default"].createElement(_boxRemove["default"], null))), _this._renderDeleteActionButton()) : /*#__PURE__*/_react["default"].createElement(_Headlight["default"], {
        style: {
          backgroundColor: '#f1f0f4'
        }
      }, assignmentData.surveylistList.length > 1 && _this._renderSurveylistListDropdown(), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Edit Quest"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          "data-edit-quest-button": assignmentData.assignmentId,
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
        size: "large",
        title: "Edit ".concat(assignmentTerm),
        ref: function ref(elem) {
          _this.editQuestModal = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_AssignmentModalContents["default"], {
        assignmentTerm: assignmentTerm,
        onSubmit: _this.onUpdateAssignment,
        initialValues: _objectSpread(_objectSpread({}, (0, _pick2["default"])(assignmentData.settings, ['languages', 'navigation', 'navigationSettings', 'frameStyleId', 'frameStyleSettings', 'showHeader', 'showFooter'])), {}, {
          title: assignmentData.label,
          subtitle: assignmentData.description,
          productId: assignmentData.product.productId || ''
        })
      })), useCourseWrapper && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Configure Course Wrapper"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_book["default"], null))),
        title: "Configure Course Wrapper for \"".concat(assignmentData.label, "\""),
        size: "large",
        render: function render(_ref5) {
          var closeModal = _ref5.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_CourseWrapper["default"], {
            assignmentData: assignmentData,
            closeModal: closeModal
          });
        }
      }), useSessionDataEntry && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Configure Session Data Entry"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_book["default"], null))),
        title: "Configure Session Data Entry",
        size: "large",
        render: function render(_ref6) {
          var closeModal = _ref6.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_SessionDataEntry["default"], {
            assignmentData: assignmentData,
            assignmentTerm: assignmentTerm,
            closeModal: closeModal
          });
        }
      }), useOutcomesDataEntry && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Configure Outcomes Data Entry"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_book["default"], null))),
        title: "Configure Outcomes Data Entry",
        size: "large",
        render: function render(_ref7) {
          var closeModal = _ref7.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_OutcomesDataEntry["default"], {
            assignmentData: assignmentData,
            assignmentTerm: assignmentTerm,
            closeModal: closeModal
          });
        }
      }), !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Settings JSON Editor"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          "data-edit-quest-json-button": assignmentData.assignmentId,
          className: "btn btn-xs btn-warning"
        }, /*#__PURE__*/_react["default"].createElement(_broom["default"], null))),
        title: "Settings JSON Editor for Quest \"".concat(assignmentData.label, "\"")
      }, /*#__PURE__*/_react["default"].createElement(_JsonForm["default"], {
        onSubmit: _this.onUpdateAssignmentJson,
        assignmentData: assignmentData
      })), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Archive"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-primary",
        "data-archive-quest-button": assignmentData.assignmentId,
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm archive?',
            description: 'Are you sure you want to archive ' + assignmentTerm + " '" + assignmentData.label + "'?",
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(_this.archiveAssignment);
        }
      }, /*#__PURE__*/_react["default"].createElement(_boxAdd["default"], null))), _this._renderDeleteActionButton());
    });
    _defineProperty(_assertThisInitialized(_this), "_renderDeleteActionButton", function () {
      var _this$props6 = _this.props,
        assignmentData = _this$props6.assignmentData,
        assignmentTerm = _this$props6.assignmentTerm;
      var deleteDescription = function deleteDescription() {
        var defaultMessage = 'Are you sure you want to delete ' + assignmentTerm + " '" + assignmentData.label + "'?";
        var sternWarning = /*#__PURE__*/_react["default"].createElement("div", null, "Deleting this data collection wave will ", /*#__PURE__*/_react["default"].createElement("strong", null, "delete all data"), " associated with this project. Are you sure you want to delete ", assignmentTerm, " ", "'", assignmentData.label, "'", "?");
        if (assignmentTerm === 'Quest' && assignmentData.deploymentList.length > 0) {
          var metrics = [];
          assignmentData.deploymentList.map(function (deployment) {
            return deployment.lastResponseEnteredAt ? metrics.push(deployment) : null;
          });
          return metrics.length > 0 ? sternWarning : defaultMessage;
        }
        return defaultMessage;
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-danger",
        "data-delete-quest-button": assignmentData.assignmentId,
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm delete?',
            description: deleteDescription(),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(_this.deleteAssignment);
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderHeaderRightSide", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].rightSide
      }, _this.props.isExpanded && !_this.props.assignmentData.archived && /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].expandedHeader
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])('text-primary', _styleAssignmentcard["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "A Survey is a collection of questions, media, and/or interactives for data collection. Surveys in a Quest are taken in the order shown."
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))), _this._renderCreateSurveyModal()), _this._renderPreviewAllBtn());
    });
    _defineProperty(_assertThisInitialized(_this), "onCreateSurvey", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(values) {
        var assignmentData, surveyListId, isSuccess;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                assignmentData = _this.props.assignmentData;
                surveyListId = assignmentData.currentSurveylistList.surveylistId;
                _context5.prev = 2;
                _context5.next = 5;
                return _this.props.createSurvey(surveyListId, values);
              case 5:
                isSuccess = _context5.sent;
                if (isSuccess) {
                  (0, _cccisdNotification["default"])("Survey \"".concat(values.title, "\"\" successfully created"));
                } else {
                  (0, _cccisdNotification["default"])({
                    type: 'danger',
                    message: 'Survey failed to create'
                  });
                }
                _this.createSurveyModal.close();
                _context5.next = 13;
                break;
              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](2);
                return _context5.abrupt("return", Promise.reject(_context5.t0));
              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 10]]);
      }));
      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_renderCreateSurveyModal", function () {
      var _this$props7 = _this.props,
        assignmentTerm = _this$props7.assignmentTerm,
        assignmentData = _this$props7.assignmentData,
        project = _this$props7.project;

      // display text to identify assignment and project names
      var assignmentProjectStr = 'For ' + assignmentTerm + " '" + assignmentData.label + "'";
      if (project.label !== '') {
        assignmentProjectStr += " in Quest Project '" + project.label + "'";
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-primary btn-sm",
          type: "button",
          "data-create-survey-button": assignmentData.assignmentId
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
          spaceRight: true
        }), "Create Survey"),
        title: "Create Survey",
        ref: function ref(elem) {
          _this.createSurveyModal = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_SurveyModalContents["default"], {
        assignmentProjectStr: assignmentProjectStr,
        onSubmit: _this.onCreateSurvey,
        initialValues: {
          isRequired: true
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderPreviewAllBtn", function () {
      var _this$props8 = _this.props,
        assignmentData = _this$props8.assignmentData,
        assignmentTerm = _this$props8.assignmentTerm;

      // show disabled button if archived
      if (assignmentData.archived) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-default btn-sm",
          type: "button",
          disabled: true
        }, "This ", assignmentTerm, " is archived");
      }

      // get total number of surveys
      var numSurveys = assignmentData.currentSurveylistList.surveyList.filter(function (item) {
        return !item.archived;
      }).length;

      // show button if surveys exist
      if (numSurveys > 0) {
        var hash = (0, _generatePreviewHash["default"])(assignmentData.assignmentId);
        return /*#__PURE__*/_react["default"].createElement("a", {
          type: "button",
          className: "btn btn-primary btn-sm",
          target: "_blank",
          rel: "noopener noreferrer",
          href: Boilerplate.url("quest/preview/quest/".concat(assignmentData.assignmentId, "/").concat(hash))
        }, /*#__PURE__*/_react["default"].createElement(_eye["default"], {
          spaceRight: true
        }), "Preview ", assignmentTerm);
      }

      // show disabled button only if collapsed
      if (!_this.props.isExpanded) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-default btn-sm",
          type: "button",
          disabled: true
        }, "There are no surveys");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (result) {
      if (!result.destination || result.destination.index === result.source.index) {
        return;
      }
      _this.props.moveSurveyAndSave({
        assignmentId: _this.props.assignmentData.assignmentId,
        sourceIndex: result.source.index,
        destinationIndex: result.destination.index
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderBody", function () {
      var _this$props9 = _this.props,
        assignmentTerm = _this$props9.assignmentTerm,
        assignmentData = _this$props9.assignmentData,
        designFilter = _this$props9.designFilter;
      var allSurveys = assignmentData.currentSurveylistList.surveyList.sort(function (a, b) {
        return a.position - b.position;
      });
      var surveys = allSurveys.filter(function (item) {
        return !item.archived;
      });
      var archivedSurveys = allSurveys.filter(function (item) {
        return item.archived;
      });
      var emptyText = '';
      if (surveys.length === 0) {
        if (assignmentData.archived) {
          // set text based on assignment archive state
          emptyText = 'This ' + assignmentTerm + ' is empty';
        } else {
          // set text based on having only-archived surveys
          emptyText = archivedSurveys.length > 0 ? 'Create a new survey...' : 'Create a survey to begin...';
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].content
      }, emptyText && /*#__PURE__*/_react["default"].createElement("h3", {
        className: _styleAssignmentcard["default"].empty
      }, emptyText), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: _this.onDragEnd
      }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
        droppableId: "droppable"
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
          ref: provided.innerRef
        }), surveys.map(function (survey, index) {
          return /*#__PURE__*/_react["default"].createElement(_SurveyCard["default"], {
            key: survey.surveyHandle,
            index: index,
            surveyData: survey,
            project: _this.props.project,
            assignmentTerm: assignmentTerm,
            assignment: assignmentData,
            isAssignmentArchived: assignmentData.archived,
            isDragDisabled: surveys.length < 2,
            designFilter: designFilter
          });
        }), provided.placeholder);
      })), archivedSurveys.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_HiddenBlock["default"], {
        label: "Archived Surveys (".concat(archivedSurveys.length, ")"),
        show: _this.props.expandedArchivedSurveys.includes(assignmentData.assignmentId),
        toggle: function toggle() {
          return _this.props.toggleArchivedSurveys(assignmentData.assignmentId);
        }
      }, archivedSurveys.map(function (survey) {
        return /*#__PURE__*/_react["default"].createElement(_SurveyCard["default"], {
          key: survey.surveyHandle,
          surveyData: survey,
          project: _this.props.project,
          assignmentTerm: assignmentTerm,
          assignment: assignmentData,
          isAssignmentArchived: assignmentData.archived,
          designFilter: designFilter
        });
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function () {
      _this.props.toggleCollapsedDesignAssignment(_this.props.assignmentData.assignmentId);
    });
    return _this;
  }
  _createClass(AssignmentCard, [{
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
        assignmentData = _this$props10.assignmentData,
        isExpanded = _this$props10.isExpanded,
        designFilter = _this$props10.designFilter;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_styleAssignmentcard["default"].cardWrapper, _defineProperty({}, _styleAssignmentcard["default"].expanded, isExpanded)),
        "data-assignment-card": assignmentData.assignmentId
      }, isExpanded && this._renderHeadlight(), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].leftSide,
        onClick: this.toggleCollapse
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: [_styleAssignmentcard["default"].collapseArrow, isExpanded ? _styleAssignmentcard["default"].expanded : _styleAssignmentcard["default"].collapsed].join(' ')
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].titleArea
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].title
      }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
        string: assignmentData.label,
        word: designFilter
      })), isExpanded && assignmentData.description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].description
      }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
        string: assignmentData.description,
        word: designFilter
      })))), this._renderHeaderRightSide()), isExpanded && this._renderBody()));
    }
  }]);
  return AssignmentCard;
}(_react["default"].Component);
_defineProperty(AssignmentCard, "propTypes", {
  isExpanded: _propTypes["default"].bool,
  project: _propTypes["default"].object.isRequired,
  assignmentData: _propTypes["default"].object.isRequired,
  assignmentTerm: _propTypes["default"].string,
  isArchived: _propTypes["default"].bool,
  numActiveSurveys: _propTypes["default"].number,
  startExpanded: _propTypes["default"].bool,
  alwaysShowSubtitle: _propTypes["default"].bool,
  updateQuest: _propTypes["default"].func,
  archiveQuest: _propTypes["default"].func,
  unarchiveQuest: _propTypes["default"].func,
  deleteQuest: _propTypes["default"].func,
  createSurvey: _propTypes["default"].func,
  toggleCollapsedDesignAssignment: _propTypes["default"].func,
  toggleArchivedSurveys: _propTypes["default"].func,
  moveSurveyAndSave: _propTypes["default"].func,
  expandedArchivedSurveys: _propTypes["default"].array,
  designFilter: _propTypes["default"].string
});
_defineProperty(AssignmentCard, "defaultProps", {
  isArchived: false,
  startExpanded: false,
  alwaysShowSubtitle: false,
  assignmentTerm: 'Assignment'
});
var _default = (0, _reactRedux.connect)(function (state) {
  return {
    expandedArchivedSurveys: state.assignment.admin.showArchivedSurveys,
    designFilter: state.assignment.admin.designFilter
  };
}, {
  updateQuest: _admin.updateQuest,
  archiveQuest: _admin.archiveQuest,
  unarchiveQuest: _admin.unarchiveQuest,
  deleteQuest: _admin.deleteQuest,
  createSurvey: _admin.createSurvey,
  toggleCollapsedDesignAssignment: _admin.toggleCollapsedDesignAssignment,
  toggleArchivedSurveys: _admin.toggleArchivedSurveys,
  moveSurveyAndSave: _admin.moveSurveyAndSave,
  setCurrentSurveyListHandle: _admin.setCurrentSurveyListHandle
})(AssignmentCard);
exports["default"] = _default;